// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blok-html[data-v-7fc92c17]{padding:20px}.blok-html[data-v-7fc92c17] iframe{max-width:100%}\n", ""]);
// Exports
module.exports = exports;
